import { render, staticRenderFns } from "./GallerySection.vue?vue&type=template&id=1c791653&"
import script from "./GallerySection.vue?vue&type=script&lang=js&"
export * from "./GallerySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports